import { IPaymentState, IPaymentData, IProcessInfo } from '../interfaces/ipayment-status';

export const PAYMENT_STATE: IPaymentState = {
    payment: <IPaymentData>{},
    active: true,
    paymentOrderId: '',
    process: <IProcessInfo>{}
};
